import { PropTypes } from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideDialog } from '../../../core/actions';
import SnoozeTaskModal from './SnoozeTaskModal';

class SnoozeTaskDialog extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    taskCompletion: PropTypes.shape({}),
    closeDialog: PropTypes.func.isRequired,
  };

  render() {
    const { closeDialog, isOpen, taskCompletion } = this.props;
    return <SnoozeTaskModal isOpen={isOpen} close={closeDialog} taskCompletion={taskCompletion} />;
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeDialog: hideDialog,
    },
    dispatch
  );
};

export default connect(null, mapDispatchToProps)(SnoozeTaskDialog);
